const breakpointValues = {
  breakpoints: ["321px", "577px", "769px", "1025px", "1201px"],
  breakpointsMax: ["320px", "576px", "768px", "1024px", "1200px"],
  labels: ["xs", "sm", "md", "lg", "xl"],
}

export const breakpoints = breakpointValues.breakpoints
export const breakpointsMax = breakpointValues.breakpointsMax
export const labels = breakpointValues.labels
